<template>
<!-- oj模块主页面 -->
  <div class="oj">
    <Breadcrumb></Breadcrumb>
    <div class="ob_main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Breadcrumb from 'common/breadcrumb/Breadcrumb';
export default {
  name: 'oj',
  components: {
    Breadcrumb
  }
};
</script>

<style lang="less" scoped>
</style>